export default __webpack_public_path__ + "static/media/paction.a86f5968.svg";